import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/wechat-mini-program"
    exact
    path="/business/services/wechat-mini-program"
    component={AsyncPage}
  />,
];
